import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

export default class IntegratorTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            integratorsData: null
        };

        this.index = 0;
    }

    componentDidMount() {
        //TODO: get API to retrieve integratorsData
    }

    componentWillUpdate(nextProps, nextState) {
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    render(){
        var self = this;
        var integratorsData = this.state.integratorsData;

        if (integratorsData !== null) {
            integratorsData = this.state.integratorsData.map(function(account) {
                return self.flattenObject(account);
            });
        }

        return (
            <div class="content">
                {integratorsData != null ? (
                    <BootstrapTable data={integratorsData} version='4' striped search pagination>
                        <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataSort={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataSort={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataSort={ true }></TableHeaderColumn>
                    </BootstrapTable>
                ) : (
                    <p>No integrators found.</p>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Integrations/IntegratorTable.jsx